import classNames from 'classnames'
import { GqlHealth } from 'src/services'
import { Text } from 'src/components/ui'

type BadgeProps = {
  health: GqlHealth
  text: string
}

const badgeStyles: Record<GqlHealth, string> = {
  GREEN: 'bg-background-brand-hover text-text-success-primary',
  YELLOW: 'bg-background-warning-secondary text-text-warning-primary',
  RED: 'bg-background-danger-secondary text-text-danger-primary',
}

export function Badge({ health, text }: BadgeProps): JSX.Element {
  return (
    <div className={classNames('px-s py-2xs rounded-2xs', badgeStyles[health])}>
      <Text variant="description" bold>
        {text}
      </Text>
    </div>
  )
}
